export class MenuAddExternalClass {
	$menus = $('.custom-pc-menu').find('a')
	constructor() {
		this.$menus.each((idx, menu) => {
			const href = $(menu).attr('href')
			// // if (!href.startsWith("http://bit1v201.on.arena.ne.jp/wordpress") && !href.startsWith("/wordpress/") && !href.startsWith("#")) {
			// if (href.startsWith("http")) {
			// 	$(menu).addClass("external");
			// 	$(menu).attr("target", "_blank");
			// }
		})
	}
}
